"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpPostsForTopicQuery = exports.blogPostsForTopicQuery = void 0;
var _bySite = _interopRequireDefault(require("./by-site"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Queries for a list of help posts by recentPostList entry
 *
 * @param {string} topicSysId - Sys id of the topic we filter by
 * @param {array[string]} slugsToExclude - List of help post slugs that should be excluded
 * @param {number} limit - Number of posts to fetch
 * @returns {object} Contentful query
 */
var helpPostsForTopicQuery = function helpPostsForTopicQuery(_ref) {
  var topicSysId = _ref.topicSysId,
    slugsToExclude = _ref.slugsToExclude,
    limit = _ref.limit;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _bySite["default"]), {}, {
    content_type: 'helpPost',
    order: '-fields.publishedAt'
  }, limit ? {
    limit: limit
  } : {}), topicSysId ? {
    'fields.topics.sys.id': topicSysId
  } : {}), slugsToExclude ? {
    'fields.slug[nin]': slugsToExclude
  } : {});
};

/**
 * Queries for a list of blog posts
 *
 * @param {string} topicSysId - Sys id of the topic we filter by
 * @param {array[string]} slugsToExclude - List of page slugs that should be excluded
 * @param {number} limit - Number of posts to fetch
 * @returns {object} Contentful query
 */
exports.helpPostsForTopicQuery = helpPostsForTopicQuery;
var blogPostsForTopicQuery = function blogPostsForTopicQuery(_ref2) {
  var topicSysId = _ref2.topicSysId,
    slugsToExclude = _ref2.slugsToExclude,
    limit = _ref2.limit;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _bySite["default"]), {}, {
    content_type: 'page_v2',
    'fields.pageType': 'blogPost',
    'fields.parent[exists]': true,
    'fields.subLevel[exists]': true,
    order: '-fields.publishedAt'
  }, limit ? {
    limit: limit
  } : {}), topicSysId ? {
    'fields.subLevel.sys.id': topicSysId
  } : {}), slugsToExclude ? {
    'fields.slug[nin]': slugsToExclude
  } : {});
};
exports.blogPostsForTopicQuery = blogPostsForTopicQuery;